export default __webpack_public_path__ + "static/media/taiwanpay.f7e881f8.svg";